const state = {
  itensContrato: Array
}

const mutations = {
  setContrato (state, obj) {
    state.itensContrato = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/contrato.js